// Builds URLs and request bodies for the search-svc API (POST /api/search/site|incident[/count]).
import { getApiIotBaseUrl } from "@/config";

const SITE_BOOLEANS     = ["onlyLiftmanagement", "onlyMyCustomers", "onlyIdleUnits", "onlyLgSmartDevices"];
const INCIDENT_BOOLEANS = ["onlyIdleIncidents", "onlyMyCustomers", "onlyOpenIncidents", "onlyMyIncidents", "includeDeleted", "onlyDeleted"];

const isEmpty = (value) => value === null || value === undefined || value === "";

function build (filter, booleans, extra) {
    const source = filter || {};
    const result = {};

    // search-svc rejects a value without a field
    if (!isEmpty(source.field) && !isEmpty(source.value)) {
        result.field = source.field;
        result.value = source.value;
    }

    if (Array.isArray(source.customer)) {
        result.customer = source.customer;
    }

    booleans.forEach(key => {
        if (source[key] !== undefined && source[key] !== null) {
            result[key] = !!source[key];
        }
    });

    (extra || []).forEach(key => {
        if (!isEmpty(source[key])) {
            result[key] = source[key];
        }
    });

    return result;
}

const Search = {
    // search-svc is reached via the IoT API gateway (API_IOT_BASE_URL), not the main one.
    // Resolved per call, because config.json is loaded asynchronously.
    url (path) {
        return `${getApiIotBaseUrl()}/api/search${path}`;
    },

    siteFilter (filter) {
        return build(filter, SITE_BOOLEANS, ["type"]);
    },

    // The persisted user filter still uses ignoreDeleted; search-svc expects includeDeleted (inverted).
    incidentFilter (filter) {
        const source = Object.assign({}, filter);
        if (source.ignoreDeleted !== undefined && source.ignoreDeleted !== null) {
            source.includeDeleted = !source.ignoreDeleted;
        }
        return build(source, INCIDENT_BOOLEANS, ["date"]);
    },

    filter (category, filter) {
        return category === 'incident' ? Search.incidentFilter(filter) : Search.siteFilter(filter);
    },

    // Body for a paged search request from a DataTables ajax data hook.
    table (d, sort, filter) {
        const body = {
            draw  : d.draw,
            start : d.start,
            length: d.length,
            filter: filter
        };

        if (sort && sort.column) {
            body.sort = { column: sort.column, dir: sort.dir };
        }

        return body;
    }
};

export default Search;
